import { MarkerClusterer } from "@googlemaps/markerclusterer";
import 'jquery-ui/dist/jquery-ui.min.js';
import 'flatpickr/dist/flatpickr.min.js';

window.poiGMaps = {};
(function (mapApp) {
	var map = null,
		_lat = -36.85,
		_lng = 174.76,
		_zoom = 11,
		autocomplete = null,
		markers = [],
		reorderDisabled = false,
		fitBounds = true,
		enableGeolocation = $("#poi-map").data("enablegeolocation"),
		markerColour = "#ee3124",
		markerCluster = null,
		infowindow,
		located = false,
		locatedCentre = null,
		userLocationMarker = null,
		categories = [],
		cityQuarters = [],
		localTags = [],
		fp = null,
		searchDateFrom = null,
		searchDateTo = null,
		Popup,
		popup;

	mapApp.init = function () {
		map = new google.maps.Map($("#poi-map")[0],
			{
				center: new google.maps.LatLng(_lat, _lng),
				zoom: _zoom,
				streetViewControl: false,
				mapTypeControl: false,
				styles: [
					{
						featureType: "poi",
						elementType: "labels",
						stylers: [
							//hide default points of interest from map
							{ visibility: "off" }
						]
					}
				]
			});

		// This event is fired when the map becomes idle after panning or zooming.
		google.maps.event.addListener(map, 'idle', handleMapIdle);

		Popup = createPopupClass();

		populateMarkers();

		// prompt browser for location
		mapApp.getCurrentLocation();
	};

	mapApp.setCentre = function (lat, lng) {
		_lat = lat;
		_lng = lng;
		map === null || map.setCenter(new google.maps.LatLng(_lat, _lng));
	};

	mapApp.setZoom = function (zoom) {
		_zoom = zoom;
		map === null || map.setZoom(_zoom);
	};

	mapApp.getCurrentLocation = function () {
		if (enableGeolocation && navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(mapApp.geoLocated);
		}
	}

	mapApp.geoLocated = function (position) {
		located = true;
		locatedCentre = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
		userLocationMarker = new google.maps.Marker({
			position: locatedCentre,
			map: map,
			title: "Your position",
			icon: {
				path: google.maps.SymbolPath.CIRCLE,
				scale: 8.5,
				fillColor: '#4B96F3',
				fillOpacity: 1,
				strokeColor: '#FFFFFF',
				strokeWeight: 2
			}
		});
		// if the user is within the map bounds, pan map to user's position
		var bounds = map.getBounds();
		if (bounds !== null && typeof bounds !== 'undefined' && bounds.contains(locatedCentre)) {
			map.panTo(locatedCentre);
		}
	};

	mapApp.showAllMarkers = function () {
		var bounds = new google.maps.LatLngBounds();
		$.each(markers,
			function () {
				this.isInCluster || markerCluster.addMarker(this);
				this.isInCluster = true;
				bounds.extend(this.position);
			});
		map.fitBounds(bounds);
	};

	mapApp.hideAllMarkers = function () {
		$.each(markers,
			function () {
				!this.isInCluster || markerCluster.removeMarker(this);
				this.isInCluster = false;
			});
	};

	mapApp.filterMarkers = function () {
		var bounds = new google.maps.LatLngBounds();
		categories = [];
		cityQuarters = [];
		localTags = [];

		$('.js-category-filter :checked').each(function () {
			categories.push($(this).val());
		});

		$('.js-city-quarter-filter :checked').each(function () {
			cityQuarters.push($(this).val());
		});

		$('.js-local-tag-filter :checked').each(function () {
			localTags.push($(this).val());
		});

		var dayPart = $('.js-day-part-filter').val();
		var dateRangeFrom = searchDateFrom !== null ? Date.parse(searchDateFrom) : null;
		var dateRangeTo = searchDateTo !== null ? Date.parse(searchDateTo) : null;

		var filterByCategory = categories.length > 0;
		var filterByCityQuarter = cityQuarters.length > 0;
		var filterByLocalTags = localTags.length > 0;
		var filterByDayPart = dayPart !== "" && dayPart !== undefined && dayPart !== null;
		var filterByDateRange = dateRangeFrom !== null;

		var markersHaveCategory = markers.some(m => m.poi.Categories && m.poi.Categories.some(p => categories.includes(p.UrlSegment)));
		var markersHaveCityQuarter = markers.some(m => cityQuarters.includes(m.poi.CityQuarter));
		var markersHaveLocalTag = markers.some(m => m.poi.LocalTags && m.poi.LocalTags.some(p => localTags.includes(p.UrlSegment)));
		var markersHaveDayPart = markers.some(m => m.poi.DayPart && m.poi.DayPart.some(p => p === dayPart));
		var markersHaveDateInDateRange = markers.some(m => (Date.parse(m.poi.StartDate) <= dateRangeTo && Date.parse(m.poi.EndDate) >= dateRangeFrom));

		if ((!filterByCategory || markersHaveCategory) &&
			(!filterByCityQuarter || markersHaveCityQuarter) &&
			(!filterByLocalTags || markersHaveLocalTag) &&
			(!filterByDayPart || markersHaveDayPart) &&
			(!filterByDateRange || markersHaveDateInDateRange)) {
			$.each(markers,
				function () {
					var hasCategory = this.poi.Categories && this.poi.Categories.some(p => categories.includes(p.UrlSegment));
					var hasCityQuarter = cityQuarters.includes(this.poi.CityQuarter);
					var hasLocalTag = this.poi.LocalTags && this.poi.LocalTags.some(p => localTags.includes(p.UrlSegment));
					var hasDayPart = this.poi.DayPart && this.poi.DayPart.some(p => p === dayPart);
					var hasDateInDateRange = false;

					if (dateRangeFrom !== null && dateRangeTo !== null) {
						hasDateInDateRange = (Date.parse(this.poi.StartDate) <= dateRangeTo && Date.parse(this.poi.EndDate) >= dateRangeFrom);
					}

					if ((!filterByCategory || hasCategory) &&
						(!filterByCityQuarter || hasCityQuarter) &&
						(!filterByLocalTags || hasLocalTag) &&
						(!filterByDayPart || hasDayPart) &&
						(!filterByDateRange || hasDateInDateRange)) {
						this.isInCluster || markerCluster.addMarker(this);
						this.isInCluster = true;
						bounds.extend(this.position);
					} else {
						!this.isInCluster || markerCluster.removeMarker(this);
						this.isInCluster = false;
					}
				});

			if (markers.some(x => x.isInCluster)) {
				map.fitBounds(bounds);
			} else {
				mapApp.reCenterMap();
			}
		} else if (filterByCategory || filterByCityQuarter || filterByLocalTags || filterByDayPart || filterByDateRange) {
			// no markers with current filters
			poiGMaps.hideAllMarkers();
			mapApp.reCenterMap();
		} else {
			poiGMaps.showAllMarkers();
		}
	};

	mapApp.reCenterMap = function () {
		map.setCenter({ lat: _lat, lng: _lng });
		map.setZoom(_zoom);
	}

	// private functions
	function populateMarkers() {
		var bounds = new google.maps.LatLngBounds();
		var poiList = $(".js-poi-list").data('poi-list');

		if (poiList !== null && typeof poiList !== 'undefined') {
			poiList.forEach(item => {
				if (item.Location !== null && typeof item.Location !== 'undefined') {
					var lat = item.Location.Latitude;
					var lng = item.Location.Longitude;
					if (lat !== "" && lng !== "") {
						//if other markers share the same location, add a little buffer to lat so each can have their own marker
						if (poiList.some(x => x !== item && x.Location === item.Location)) {
							const incrementValue = 0.00002;
							var latIncrement = incrementValue;
							poiList.filter(x => x !== item && x.Location === item.Location).forEach(itemToUpdate => {
								var objIndex = poiList.findIndex((obj => obj === itemToUpdate));
								var newLat = parseFloat(location[0]) + latIncrement;
								poiList[objIndex].Location = `${newLat},${lng}`;
								latIncrement += incrementValue;
							});
						}
						var position = new google.maps.LatLng(lat, lng);
						var marker = new google.maps.Marker({
							position: position,
							icon: markerSymbol(markerColour),
							isInCluster: true,
							poi: item
						});

						google.maps.event.addListener(marker, 'click', function () { markerClick(marker) });

						markers.push(marker);

						bounds.extend(position);
					}
				}
			});
		}

		const renderer = {
			render({ count, position }) {
				return new google.maps.Marker({
					label: { text: String(count), color: "white", fontSize: "12px", width: 40, height: 40 },
					position,
					icon: getGoogleClusterInlineSvg(markerColour)
				});
			}
		}

		markerCluster = new MarkerClusterer({ map, markers, renderer });

		if (fitBounds) {
			reorderDisabled = true;
			map.fitBounds(bounds);
		}
	}

	function markerSymbol(color) {
		return {
			path: 'M160,0C71.641,0,0,71.625,0,160c0,24.75,5.625,48.219,15.672,69.125 C16.233, 230.313,160,512,160,512l142.594-279.375C313.719, 210.844,320,186.156,320,160C320, 71.625,248.375,0,160,0',
			anchor: new google.maps.Point(160, 512),
			fillColor: color,
			fillOpacity: 1,
			scale: 0.09
		};
	}

	function getGoogleClusterInlineSvg(color) {
		// https://stackoverflow.com/questions/28178080/getting-google-map-markerclusterer-plus-icons-in-one-color/37302915#37302915
		var encoded = window.btoa('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="40" width="40"><circle cx="20" cy="20" r="20" fill="' + color + '"></circle></svg>');
		return ('data:image/svg+xml;base64,' + encoded);
	}

	function markerClick(marker) {
		showPopup(marker);
	}

	function showPopup(marker) {
		removePopupFromMap();
		var content = document.createElement('div');
		content.innerHTML = '<div class="info-window">' + formatPoi(marker.poi) + '</div>';
		popup = new Popup(marker.position, content);
		popup.setMap(map);
	}

	function closePopup(event) {
		if (event) { event.preventDefault(); }
		removePopupFromMap();
	}

	function removePopupFromMap() {
		if (popup) {
			popup.setMap(null);
		}
	}

	function formatPoi(poi) {
		const innerHtml = '<div class="event-panel__inner js-outlet" data-id="' + poi.Id + '" style="border: none; max-width: 300px">' +
			'<h4 class="stockist-name">' + poi.Name + '</h4>' +
			(poi.Description ? '<div class="event-panel__group">' + poi.Description + '</div>' : "") +
			(poi.FormattedDate ? '<div class="event-panel__group"><h3 class="small">WHEN</h3>' + formatPoiWhen(poi) + '</div>' : "") +
			(poi.Where ? '<div class="event-panel__group"><h3 class="small">WHERE</h3>' + formatPoiWhere(poi) + '</div>' : "") +
			(poi.SponsorsLogo ? '<div class="event-panel__group"><img srcset="' + poi.SponsorsLogo + ', ' + poi.SponsorsLogo2x + ' 2x" src="' + poi.SponsorsLogo + '" alt="Our Auckland"></div>' : "") +
			(poi.Link ? '<a href="' + poi.Link + '" class="button button--theme-news" target="_blank" style="min-width: unset;">View more info</a>' : "") +
			'</div>';
		return innerHtml;
	}

	function formatPoiWhen(poi) {
		if (poi.OpeningHours) {
			return poi.FormattedDate + '</br>' + poi.OpeningHours;
		}
		return poi.FormattedDate;
	}

	function formatPoiWhere(poi) {
		if (poi.WhereIsClickable) {
			return '<a href="https://maps.google.com/maps?q=' + poi.Where + '" target="_blank">' + poi.Where + '</a>';
		}
		return poi.Where;
	}

	function handleMapIdle() {
		// check if the centre of the map has changed
		var currentMapCentre = map.getCenter();
		if (currentMapCentre.lat !== _lat || currentMapCentre.lng !== _lng) {
			_lat = currentMapCentre.lat;
			_lng = currentMapCentre.lng;

			// don't reorder the listings if the panning happened because a location was selected in the list
			if (reorderDisabled) {
				reorderDisabled = false;
				return;
			}
		}
	}


	/**
	 * Returns the custom Popup class
	 * @returns {Popup} Popup class
	 * https://developers.google.com/maps/documentation/javascript/examples/overlay-popup
	 * Unfortunately, the Popup class can only be defined after
	 * google.maps.OverlayView is defined, when the Maps API is loaded.
	 * This function should be called by initMap.
	 */
	function createPopupClass() {
		/**
		 * A customized popup on the map.
		 * @param {!google.maps.LatLng} position The map position
		 * @param {!string} contentString The HTML string containing the popup markup
		 * @constructor
		 * @extends {google.maps.OverlayView}
		 */
		function Popup(position, content) {

			this.position = position;
			content.classList.add('map-popup');

			var closeButton = document.createElement('button');
			closeButton.classList.add('map-popup__button');
			closeButton.innerHTML = '<svg class="icon icon-close" role="presentation" aria-hidden="true"><use xlink:href="#icon-close"></use></svg><span class="screen-reader-text">Close</span>';
			content.appendChild(closeButton);

			this.containerDiv = document.createElement('div');
			this.containerDiv.classList.add('map-popup-container');
			this.containerDiv.appendChild(content);

			// Optionally stop clicks, etc., from bubbling up to the map.
			//google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv);
		}
		// ES5 magic to extend google.maps.OverlayView.
		Popup.prototype = Object.create(google.maps.OverlayView.prototype);

		/** Called when the popup is added to the map. */
		Popup.prototype.onAdd = function () {
			this.getPanes().floatPane.appendChild(this.containerDiv);

			// This handler allows right click events on anchor tags within the popup
			var allowAnchorRightClicksHandler = function (e) {
				if (e.target.nodeName === "A") {
					e.cancelBubble = true;
					if (e.stopPropagation) {
						e.stopPropagation();
					}
				}
			};
			this.contextListener = google.maps.event.addDomListener(this.containerDiv, "contextmenu", allowAnchorRightClicksHandler);

			// pan the map so the marker and popup are visible
			var containerPosition = this.containerDiv.getBoundingClientRect();
			var positionPoint = this.getProjection().fromLatLngToDivPixel(this.position);
			// get the coordinate at the point, add half the width of the popup plus a margin to the x position
			var shiftedLatLng = this.getProjection().fromDivPixelToLatLng(new google.maps.Point(positionPoint.x + containerPosition.width / 2 + 15, positionPoint.y));
			this.map.panTo(shiftedLatLng);
		};

		/** Called when the popup is removed from the map. */
		Popup.prototype.onRemove = function () {
			if (this.contextListener) {
				google.maps.event.removeListener(this.contextListener);
				this.contextListener = null;
			}
			if (this.containerDiv.parentElement) {
				this.containerDiv.parentElement.removeChild(this.containerDiv);
			}
		};

		/** Called each frame when the popup needs to draw itself. */
		Popup.prototype.draw = function () {
			var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);

			// Hide the popup when it is far out of view.
			var display =
				Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
					'block' :
					'none';

			if (display === 'block') {
				this.containerDiv.style.left = divPosition.x + 'px';
				this.containerDiv.style.top = divPosition.y + 'px';
			}
			if (this.containerDiv.style.display !== display) {
				this.containerDiv.style.display = display;
			}
		};

		return Popup;
	}

	$(document).ready(function () {
		$(".js-toggle-poi-filters").on("click", function () {
			$(".poi").toggleClass("is-expanded");
		});

		$(document).on("click", ".map-popup__button", closePopup);

		var icons = {
			header: "iconClose",    // custom icon class
			activeHeader: "iconOpen" // custom icon class
		};

		$("#accordion > div").accordion({
			header: "h6",
			collapsible: true,
			active: false,
			heightStyle: "panel",
			fillSpace: true,
			autoHeight: false,
			icons: icons
		});

		$('.js-map-filter :checkbox, select').on('change', function () {
			poiGMaps.filterMarkers();
		});

		fp = $('#filter-date-range-poi').flatpickr({
			enableTime: false,
			altInput: true,
			altFormat: "d M Y",
			dateFormat: "Y-m-d",
			locale: {
				firstDayOfWeek: 1
			},
			mode: "range",
			minDate: "today",
			disableMobile: "true",
			onChange: function (selectedDates, dateStr, instance) {
				if (selectedDates && selectedDates.length == 2) {
					$("#searchDateFrom").val(flatpickr.formatDate(selectedDates[0], "Y-m-d"));
					$("#searchDateTo").val(flatpickr.formatDate(selectedDates[1], "Y-m-d"));
					searchDateFrom = flatpickr.formatDate(selectedDates[0], "Y-m-d H:i");
					searchDateTo = flatpickr.formatDate(selectedDates[1], "Y-m-d H:i");
					instance.close();
					poiGMaps.filterMarkers();
				}
			}
		});

		$('.js-clear-filters').on('click', function (e) {
			e.preventDefault();
			poiGMaps.showAllMarkers();

			$('.js-category-filter :checked').each(function () {
				$(this).prop('checked', false);
			});

			$('.js-city-quarter-filter :checked').each(function () {
				$(this).prop('checked', false);
			});

			$('.js-local-tag-filter :checked').each(function () {
				$(this).prop('checked', false);
			});

			$('.js-day-part-filter').val("");

			fp.clear();
		});

		if (enableGeolocation && navigator.geolocation) {
			setInterval(function () {
				mapApp.getCurrentLocation();
			}, 30000);
		}

	});

})(poiGMaps);
